import React, { useEffect, useState } from "react"
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons"
import { empty } from "../../functions"
import "./linput.css"
export interface ILInput {
  legendText?: string,
  placeholder?: string,
  noLegend?: boolean,
  val: string,
  setVal?: React.Dispatch<React.SetStateAction<string>> | null,
  validemail?:boolean,
  readonly?: boolean,
  hidden?: boolean,
  bgROColor?: string,
  type?: string,

}
export const LInput = ({val, setVal = null, type = 'text',validemail=false, readonly = false, hidden = false, noLegend = false, legendText = '', placeholder = '', bgROColor= '#e9ecef'}:ILInput) => {
  const [itype, setItype] = useState(type)
  const [showHideClass, setShowHideClass] = useState('')

  useEffect(() => {
    setShowHideClass(empty(val)? 'linput-paswd-show-hide-on-fill cp' : 'linput-paswd-show-hide cp')
  }, [val])

  const onSetVal = (v: string) => {
    if(setVal != null) setVal(v)
  }

  const onShowHidePswdClicked = () => {
    if(itype === 'text') setItype('password')
    else setItype('text')
  }

  let isText = itype === 'text'
if(val==="")
  validemail=false
  return (
    <fieldset className="linput-fieldset" style={{background: (readonly? bgROColor: 'white')}}>
      <legend hidden={noLegend || empty(val)} className="linput-legend">{legendText}</legend>
      <div className="row col-12 p-0 m-0 h-100">
        <input type={itype} readOnly={readonly} hidden={hidden} value={val} onChange={e => onSetVal(e.target.value)} className="linput-input" placeholder={placeholder}/>
        {legendText==="Email"?<span className={validemail?"indicator indicator_green":!validemail&&val!==""?"indicator indicator_red":""}></span>:null}
        <div className={showHideClass} hidden={type !== 'password'} onClick={onShowHidePswdClicked}>{isText ? <EyeFill/> : <EyeSlashFill/>} </div>
      </div>
    </fieldset>
  )
}
